/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Typography, Chip } from '@mui/material';

import NumberUtils from 'commons/utils/numberUtils';

const useStyles = makeStyles()((theme) => ({
  subBoxTextColor: {
    color: 'white',
  },
  discountChip: {
    background: 'linear-gradient(45deg, hsla(256, 79%, 72%, 1) 30%, #22b8e5 90%)',
    color: 'white',
  },
  discountChipBlackFriday: {
    background: '#fbff00',
    color: 'black',
    fontWeight: 'bold',
  },
  discountChipNewYear: {
    backgroundColor: '#2ED195',
    color: 'white',
    fontWeight: 'bold',
  },
  oldPriceLabel: {
    color: 'white',
    textDecoration: 'line-through',
    textDecorationThickness: '1px',
  },
}));

function DiscountCardWithDuration({ stripePlan, discountInfo, isBlackFridayPromo, isNewYearPromo }) {
  const { classes } = useStyles();

  const { price: planPrice, periodType, oldPrice } = stripePlan;
  const { description, fixedAmountDiscount, percentageDiscount, specialLabel } = discountInfo;

  const isSpecialPromo = isBlackFridayPromo || isNewYearPromo;

  return (
    <div>
      <div>
        {isNewYearPromo ? (
          <div style={{ display: 'inline-block' }}>
            {oldPrice && (
              <Typography className={classes.oldPriceLabel}>
                De: {NumberUtils.toCurrency(oldPrice, 2)}
              </Typography>
            )}
            <Typography variant="h2" className={classes.subBoxTextColor}>
              {percentageDiscount
                ? NumberUtils.toCurrency(planPrice - (planPrice * percentageDiscount) / 100, 2)
                : NumberUtils.toCurrency(planPrice - fixedAmountDiscount, 2)}
            </Typography>
          </div>
        ) : (
          <Typography variant="h2" gutterBottom component="span" className={classes.subBoxTextColor}>
            {percentageDiscount
              ? NumberUtils.toCurrency(planPrice - (planPrice * percentageDiscount) / 100, 2)
              : NumberUtils.toCurrency(planPrice - fixedAmountDiscount, 2)}
          </Typography>
        )}
        {description && (
          <Typography variant="h6" gutterBottom component="span" className={classes.subBoxTextColor}>
            &nbsp;{description}
          </Typography>
        )}
        &nbsp;
        {specialLabel && (
          <Chip
            label={specialLabel}
            className={
              isSpecialPromo
                ? isBlackFridayPromo
                  ? classes.discountChipBlackFriday
                  : classes.discountChipNewYear
                : classes.discountChip
            }
          />
        )}
      </div>
      <div>
        {isNewYearPromo ? (
          <div style={{ display: 'inline-block' }}>
            {oldPrice && (
              <Typography className={classes.oldPriceLabel}>
                De: {NumberUtils.toCurrency(oldPrice, 2)}
              </Typography>
            )}

            <Typography variant="h3" className={classes.subBoxTextColor}>
              {NumberUtils.toCurrency(planPrice, 2)}
            </Typography>
          </div>
        ) : (
          <Typography variant="h3" gutterBottom component="span" className={classes.subBoxTextColor}>
            {NumberUtils.toCurrency(planPrice, 2)}
          </Typography>
        )}

        <Typography variant="h6" gutterBottom component="span" className={classes.subBoxTextColor}>
          &nbsp;{periodType === 'YEARLY' && 'anos seguintes'}
          {periodType === 'MONTHLY' && 'meses seguintes'}
          {periodType === 'QUARTERLY' && 'trimestres seguintes'}
        </Typography>
      </div>
    </div>
  );
}

export default DiscountCardWithDuration;
